import React from 'react';
import classNames from 'classnames';
import { RadioImpl, type IRCRadioProps } from '../RCRadioGroup/RadioImpl';

interface Props extends IRCRadioProps {
  /** Additional markup below the label/sublabel */
  children?: React.ReactNode;
}

/**
 * Internal component for rendering radio options as cards, you should never need to use this directly.
 * See RCRadioGroup
 */
export function RadioCardImpl(props: Props) {
  return (
    <div className={classNames(
      'rc-radio-card',
      { 'rc-radio-card--disabled': props.disabled },
      { 'rc-radio-card--checked': props.checked },
    )}>
      <div className="rc-radio-card__main">
        <RadioImpl
          id={props.id}
          label={props.label}
          sublabel={props.sublabel}
          name={props.name}
          checked={props.checked}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled}
        />
      </div>
      {props.children && (
        <div className="rc-radio-card__content">
          {props.children}
        </div>
      )}
    </div>
  );
}
